import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './App.jsx';
import { msalConfig } from './auth/msalConfig';
import { AuthProvider } from './auth/useAuth';
import '../src/styles/style.css';

// Initialise MSAL instance once at app startup
const msalInstance = new PublicClientApplication(msalConfig);

// Handle redirect promise (required for redirect-based login flows)
msalInstance.initialize().then(() => {
  // Set active account if one exists in cache
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for successful login events and set the active account
  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload?.account
    ) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  ReactDOM.createRoot(document.getElementById('root')).render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        {/* AuthProvider wraps the whole app so useAuth() works everywhere.
            It handles both SSO (via MSAL hooks inside) and local JWT auth. */}
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  );
});
